<template>
  <div class="card-body">
	<div v-if="success_np != ''" class="alert alert-success" role="alert"> {{success_np}} </div>
	<form @submit="newpayslipformSubmit" enctype="multipart/form-data">
	  <div class="form-group row">
		<label for="status"  class="col-md-4 col-form-label">Employee</label>
		<div class="col-md-12">
		  <select id="employee_np" v-model="employee_np" name="employee_np" required class="form-control ">
           <option value="">Select an Employee</option>
			<option v-for='emply in employees_np'  :value='emply.employee_id'>{{ emply.name }}</option>
		  </select>
		</div>
	  </div>

	  <div class="form-group">
		<div class="col-md-6">
		  <button class="btn btn-primary btn-full-width">Create Payslip</button>
		</div>
	  </div>
	</form>
  </div>			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
			 // console.log(this.componentdata);  
		  },
		  props: [ 'payrun_id'],
				 
   
		  data() {
			  
			  return {
			      employees_np : [],
                  success_np : '',
                  
				  prun_id_np:22,
                  employee_np:'',

			  }
		  },
		  
		  methods:{
		  

			  getEmployeesnewpayslip: function()
			  {
  
                     axios.get(this.$api_url+'/remainingemployees/'+this.prun_id_np , {
							  params: {
								  page: 1,

							  }
					  }).then(function(response){
					   
                       //console.log(response.data.employees); 
					   
					  this.employees_np = response.data.employees;
  
  
				  }.bind(this));
			  },
			  
 
  
 
 			  newpayslipformSubmit: function(e)
			  {
                       e.preventDefault();
                     axios.get(this.$api_url+'/createpayslipbyid/'+this.prun_id_np+'/'+this.employee_np , {
							  params: {
								  page: 1,

							  }
					  }).then(function(response){
					   
                       //alert(1);
					   
                       //console.log(response.data.employees); 

  
  
				  }.bind(this));
			  },
			  
  

  
  
		  },
		  created: function(){
		  
		     this.getEmployeesnewpayslip();
	
			 	
		  }
	  }
  </script>